export default __webpack_public_path__ + "static/media/Pintar.28ceb625.svg";